import { render, staticRenderFns } from "./RelatedNews.vue?vue&type=template&id=c567c53e"
import script from "./RelatedNews.vue?vue&type=script&lang=js"
export * from "./RelatedNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports